import { fetchSchemaRoutine } from 'app/branches/actions';
import { showMessage } from 'app/messages/actions';
import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { useWorkingCopyStore } from '../../branches/store/working-copy-store.js';
import {
  type GetSchemaVersionResponse,
  getSchemaHistoryRoutine,
  type RestoreSchemaRequest,
  type RestoreSchemaResponse
} from '../actions.js';
import { getSchemaVersion, restoreSchemaVersion } from '../api.js';

export function* restoreSchemaSaga(payload: RestoreSchemaRequest): SagaIterator {
  yield put(showMessage('info', 'Schema restoration started.', 3000));
  const restoredSchema: RestoreSchemaResponse = yield call(restoreSchemaVersion, payload);
  /* We need to poll for the new version to be saved and uploaded to S3,
  otherwise the schema returned by getSchemaVersion will be null! */
  let restoredSchemaData: GetSchemaVersionResponse = yield call(getSchemaVersion, restoredSchema);
  while (restoredSchemaData.status === 'Schema not found') {
    restoredSchemaData = yield call(getSchemaVersion, restoredSchema);
  }

  yield call(useWorkingCopyStore.getState().reset);
  yield put(fetchSchemaRoutine.requested(undefined, { runtime: false }));
  yield put(fetchSchemaRoutine.requested(undefined, { runtime: true }));
  yield put(getSchemaHistoryRoutine.requested({}));
  return restoredSchemaData;
}

export function* handleRestoreSchemaSagaFulfilled(): SagaIterator {
  yield put(showMessage('info', 'Schema successfully restored.', 3000));
}
